"use client";

import React, { useState } from "react";
import { usePathname } from "next/navigation";
import Team_Home_Layout1 from "./Team/TeamLayouts/Home/Team_Home_Layout1";
import Team_Home_Layout2 from "./Team/TeamLayouts/Home/Team_Home_Layout2";
import Team_Home_Layout3 from "./Team/TeamLayouts/Home/Team_Home_Layout3";
import Team_Home_Layout4 from "./Team/TeamLayouts/Home/Team_Home_Layout4";
import Team_Home_Layout5 from "./Team/TeamLayouts/Home/Team_Home_Layout5";
import About from "./About/About";

interface Founder {
  id: number;
  name: string;
  about: string;
  designation: string;
  picture: {
    data: {
      attributes: {
        url: string;
        alternativeText: string | null;
      };
    };
  };
}

interface TeamProps {
  data: {
    title: string;
    founders: Founder[];
    useH1Tag?: boolean;
    isLive?: boolean;
  };
}

export default function Team({ data }: TeamProps) {
  const pathname = usePathname();
  const [selectedLayout, setSelectedLayout] = useState("layout1");
  const isHomePage = pathname === "/";
  const isDev = process.env.NODE_ENV === "development";

  // console.log("Team component data:", data);
  // console.log("Current pathname:", pathname);
  // console.log("isHomePage:", isHomePage);

  if (!data?.founders || data.founders.length === 0) {
    return null;
  }

  const renderLayout = () => {
    switch (selectedLayout) {
      case "layout1":
        return <Team_Home_Layout1 data={data} />;
      case "layout2":
        return <Team_Home_Layout2 data={data} />;
      case "layout3":
        return <Team_Home_Layout3 data={data} />;
      case "layout4":
        return <Team_Home_Layout4 data={data} />;
      case "layout5":
        return <Team_Home_Layout5 data={data} />;
      default:
        return <Team_Home_Layout1 data={data} />;
    }
  };

  return (
    <>
      {/* Comment Velvet Kiss About Page Hard Code Component Calling */}
      {/* <About/> */}

      <div className="w-full">
        {/* Layout selector - shown only in dev mode */}
        {isDev && (
          <div className="w-full flex justify-end px-4 sm:px-6 md:px-8 mt-4 mb-2">
            <div className="inline-block">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Choose Team Layout
              </label>
              <select
                value={selectedLayout}
                onChange={(e) => setSelectedLayout(e.target.value)}
                className="text-sm px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#B78D65]"
              >
                <option value="layout1">Layout 1 (Detailed Cards)</option>
                <option value="layout2">Layout 2 (Grid View)</option>
                <option value="layout3">Layout 3 (Accordion)</option>
                <option value="layout4">Layout 4 (Sidebar List)</option>
                <option value="layout5">Layout 5 (Circular Avatars)</option>
              </select>
            </div>
          </div>
        )}

        {renderLayout()}
      </div>
      {/* <FoundersJourney /> */}
    </>
  );
}
